import React, { useState } from "react";
import { Space, Switch } from "antd";

const EditorSwitch = ({ isLoading, handleSwitchChange, state1, state2, initialState }) => {
  const [isAll, setIsAll] = useState(initialState === true ? true : false);

  console.log({ initialState, isAll })
  return (<Space>
    <p className={!isAll ? 'font-bold dark:text-white' : 'dark:text-white'}>{state2}</p>
    <Switch
      className={`text-black ml-2 bg-slate-500`}
      onChange={(checked) => {
        handleSwitchChange(checked);
        setIsAll((val) => !val)
      }}
      loading={isLoading}
      style={{ backgroundColor: '#1890ff' }}
      checked={isAll}
    />
    <p className={isAll ? 'font-bold dark:text-white' : 'dark:text-white'}>{state1}</p>
  </Space>
  );
};

export default React.memo(EditorSwitch);